import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Col, Label, Row } from 'reactstrap';
import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';

//Api
import setor_api from '../../../api/setor_api';

//Helpers
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';

//Shared
import FiltroPrefeitura from '../../Shared/FiltroPrefeitura';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Estado inicial da regional
function initialStateRegional(prefeitura_id = "") {
    return { descricao: "", tbPrefeituras_Id: prefeitura_id, geoJson: null }
}

export default function Regionais({ permissao }) {
    //Estado que guarda os campos de controle da regional para Cadastro/Edição
    const [regional, setRegional] = useState(initialStateRegional);

    //Estado que guarda a lista de regionais da tabela
    const [regionais, setRegionais] = useState([]);

    //Estado de controle de exibição do modal
    const [openModal, setOpenModal] = useState(false);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos erros nos campos de cadastro/edição
    const [errors, setErrors] = useState({});

    //Estado que guarda o id da prefeitura
    const [prefeitura_Id, setPrefeitura_Id] = useState(null);

    //Estado de controle do centro do geojson
    const [centerGeoJson, setCenterGeoJson] = useState(null);

    //Estado de referencia do mapa
    const [map, setMap] = useState(null);

    //Campos obrigatorios no cadastro/edição de regional
    const campos = [
        objCampo({ name: "descricao", required: true }),
    ];

    //Função que faz a troca de estado do modal de cadastro/Edição
    const toggleModal = () => {
        if (openModal) {
            setErrors({});
            setRegional(initialStateRegional(regional.tbPrefeituras_Id));
            setCenterGeoJson(null);
        }
        if (prefeitura_Id !== "") {
            setOpenModal(!openModal);
        } else {
            showMessage("Aviso", "Selecione uma prefeitura para adicionar uma regional", "info", null);
        }

    };

    //Função que carrega a lista de regionais
    const loadRegionais = (prefeitura_id) => {
        setLoading(true);
        setor_api.GetList(prefeitura_id).then(response => {
            setRegionais(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Função que faz o controle do id da prefeitura e carrega as regionais
    const handlePrefeitura = (value) => {
        setPrefeitura_Id(value);
        loadRegionais(value);
        setRegional(initialStateRegional(value));
    }

    //Função que adiciona/Edita a regional
    const addNovaRegional = () => {

        const _errors = validarCampos(regional, campos);
        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }

        const _regional = { ...regional }
        if (!!_regional.geoJson)
            _regional.geoJson = JSON.stringify(_regional.geoJson);

        setLoading(true);
        if (!regional.id) {
            setor_api.Post(_regional).then(response => {
                showMessage("Sucesso", "Sucesso ao cadastrar a regional", "success");
                toggleModal();
                loadRegionais(prefeitura_Id);
                setRegional(initialStateRegional(prefeitura_Id));
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            setor_api.Put(_regional).then(response => {
                setRegional(initialStateRegional(prefeitura_Id));
                loadRegionais(prefeitura_Id);
                toggleModal();
                showMessage("Sucesso", "Sucesso ao editar a regional", "success");
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    //OnChange dos campos do formulario da regional
    const onChangeRegional = (e) => {
        const { name, value } = e.target;
        if (name == "tbPrefeituras_Id") {
            if (value == "") {
                setRegionais([]);
            } else {
                loadRegionais(prefeitura_Id);
            }
        }
        setRegional({
            ...regional,
            [name]: value
        })
    }

    //OnChange do arquivo GeoJson
    const onChangeFileGeoJson = (event) => {
        const file = event.target.files[0];

        //Verificar se um arquivo foi selecionado
        if (!file) {
            showMessage("Aviso", "Por favor, selecione um arquivo.", "error", null);
            return;
        }

        //Verifica a extensão do arquivo
        const validExtension = '.geojson';
        const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

        if (fileExtension !== validExtension) {
            showMessage("Aviso", "Por favor, selecione um arquivo GeoJSON.", "error", null);
            //Limpa o campo de seleção de arquivo
            event.target.value = null;
            return;
        }
        setLoading(true);
        const reader = new FileReader();
        reader.onload = (e) => {
            const content = e.target.result;
            if (content) {
                var _content = JSON.parse(content);

                if (!_content.geometry) {
                    _content = _content.features[0]
                }
                
                if (_content.geometry.type != "Polygon") {
                    showMessage("Aviso", "É permitido somente GeoJSON do tipo Polygon", "error", null);
                    //Limpa o campo de seleção de arquivo
                    event.target.value = null;
                    setLoading(false);
                    return;
                }

                if (_content.geometry && _content.geometry.coordinates && _content.geometry.coordinates.length > 0 && _content.geometry.coordinates[0].length > 0) {
                    setCenterGeoJson([_content.geometry.coordinates[0][0][1], _content.geometry.coordinates[0][0][0]]);
                    if (map && regional.geoJson)
                        map.flyTo([_content.geometry.coordinates[0][0][1], _content.geometry.coordinates[0][0][0]]);

                }
                setRegional({
                    ...regional,
                    geoJson: _content
                });
            }
            setLoading(false);
        };
        reader.readAsText(file);
    };

    //Função que é executada ao clicar no botão editar da lista
    const editarRegional = (item) => {
        setLoading(true);
        setor_api.GetItem(item.id).then(response => {
            if (!!response.data.geoJson) {
                response.data.geoJson = JSON.parse(response.data.geoJson);
                setCenterGeoJson([response.data.geoJson.geometry.coordinates[0][0][1], response.data.geoJson.geometry.coordinates[0][0][0]]);
            } 
            setRegional(response.data);

            toggleModal();
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Variavel que guarda as ações da tabela de regionais
    const actions = [];
    if (permissao === "Editar")
        actions.push(actionsTable.editar(editarRegional));

    //Headers da tabela de regionais
    const headers = [
        { value: "Descrição", objectValue: "descricao", align: "left" }
    ]

    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={toggleModal}>
                <ModalCustomized isOpen={openModal} toggle={toggleModal} btnClose title={regional.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Nova Regional"} btnAction={regional.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"} btnActionColor={regional.id ? "warning text-light" : "success"} onClickBtnAction={addNovaRegional} >
                    <Row className='mb-4'>
                        <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="12" >
                            <TextField maxLength={"100"} invalid={errors.descricao ? true : false} label={"* Descrição"} name="descricao" value={regional.descricao} onChange={onChangeRegional} />
                            <PrintValidate field={"descricao"} errors={errors} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="12" >
                            <TextField type={"file"} label={"Importar GeoJSON"} name="geoJson" value={regional.geoJson} onChange={onChangeFileGeoJson} />
                            <PrintValidate field={"geoJson"} errors={errors} />
                        </Col>
                    </Row>
                    {regional.geoJson && centerGeoJson != null && (
                        <Row >
                            <Col md={12} lg={12} >
                                <Label>Mapa</Label>
                                <div className='rounded overflow-hidden'>
                                    <MapContainer whenCreated={setMap} style={{ height: "400px" }} center={centerGeoJson} zoom={11}>
                                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                        {!loading && <GeoJSON data={regional.geoJson} />}
                                    </MapContainer>
                                </div>
                            </Col>
                        </Row>
                    )}
                </ModalCustomized>
                <FiltroPrefeitura handleValue={handlePrefeitura} />
                <div className="mt-4">
                    <TabelaListagem actions={actions} title={"Lista de regionais"} options={{ print: false, search: true, pagination: true }} headers={headers} items={regionais} />
                </div>
            </MainCard>
        </>
    )
}
